const BRAND_MARKETPLACE_CACHE_PREFIX = 'brand_marketplace_';

export const requestCache = new Map();
export const inFlightRequests = new Map();

export const getBrandMarketplaceCacheStorageKey = (queryKey) => (
  `${BRAND_MARKETPLACE_CACHE_PREFIX}${btoa(queryKey)}`
);

export const clearBrandMarketplaceCache = () => {
  requestCache.clear();
  inFlightRequests.clear();

  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(BRAND_MARKETPLACE_CACHE_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));

    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('[useBrandMarketplace] 🗑️ Invalidated all marketplace caches');
    }
  } catch (error) {
    console.warn('[useBrandMarketplace] Error clearing localStorage cache:', error);
  }
};

export default clearBrandMarketplaceCache;
